const baseOss={
  dev: 'https://bcdt-oss.bcjyjt.com',
  pro: 'https://bcdt-oss.bcjyjt.com',
  uat:'https://ydd-oss.2vm.co'
}
export default {
  baseUrl: {
    dev: 'https://fch-api.test.bcvip.ink/',
    pro: 'https://fch-api.bcjyjt.com/',
    uat:'https://fch-api.test.bcvip.ink/'
  },
  oss:baseOss[process.env.VUE_APP_ENV]
}
